// extracted by css-extract-rspack-plugin
export default {"row":"LQrCC","link":"asYuS"};